// ==========================================
// 1. LANDING PAGE ENGINE
// ==========================================
function pnmFormatMoney(amount) {
  const currency = window.pnmCurrencyIso || 'GBP';
  let locale = window.pnmLocale;
  if (!locale || locale === '-') {
    locale = 'en-GB';
  }
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency
    }).format(amount);
  } catch(e) {
    return `£${amount.toFixed(2)}`;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const styleButtons = document.querySelectorAll('.pm-style-selection__button');
  if (styleButtons.length === 0) return; 

  const amountWrapper = document.querySelector('.pm-amount-selection__wrapper');
  const sizeWrappers = document.querySelectorAll('.pm-size-selection__wrapper');
  const amountButtons = document.querySelectorAll('.pm-amount-selection__button');
  const sizeButtons = document.querySelectorAll('.pm-size-selection__button');
  const toggleArrows = document.querySelectorAll('.toggle-arrow'); 
  const startButton = document.querySelector('.pm-start-picking__button');
  const dietarySelect = document.getElementById('pm-dietary-select'); 
  
  if (dietarySelect) {
    dietarySelect.addEventListener('change', (e) => {
      localStorage.setItem('selectedCollection', e.target.value.toLowerCase().replace(/\s+/g, '-'));
    });
  }

  styleButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      styleButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      
      const rawName = this.getAttribute('data-button-name') || this.innerText || '';
      let selectedStyle = rawName.toLowerCase().trim();

      amountButtons.forEach(b => b.classList.remove('active'));
      sizeButtons.forEach(b => b.classList.remove('active'));
      if (startButton) startButton.classList.remove('active', 'enabled');

      let hasVariants = false;

      if (selectedStyle.includes("bag") || this.getAttribute('data-has-amounts') === 'true') {
        if (amountWrapper) amountWrapper.classList.add('active');
        sizeWrappers.forEach(w => w.classList.remove('active'));
        hasVariants = true; 
      } else {
        if (amountWrapper) amountWrapper.classList.remove('active');
        sizeWrappers.forEach(w => w.classList.remove('active'));
        
        const origStyle = this.getAttribute('data-button-name') || this.innerText.trim();
        const targetWrapper = document.querySelector(`.pm-size-selection__wrapper[data-style="${origStyle}"]`);
        if (targetWrapper) {
          targetWrapper.classList.add('active');
          hasVariants = true; 
        }
      }

      toggleArrows.forEach(arrow => {
        arrow.style.setProperty('display', hasVariants ? 'flex' : 'none', 'important');
      });

      if (!hasVariants) {
        const variantId = this.getAttribute('data-variant-id');
        const recipe = this.getAttribute('data-recipe');
        const image = this.getAttribute('data-image');
        const price = this.getAttribute('data-price');
        const title = this.querySelector('h3') ? this.querySelector('h3').innerText.trim() : '';

        if (variantId) localStorage.setItem('pnm_parent_id', variantId);
        if (recipe) localStorage.setItem('pnm_recipe', recipe);
        if (image) localStorage.setItem('pnm_parent_image', image);
        if (price) localStorage.setItem('pnm_parent_price', price);
        if (title) localStorage.setItem('pnm_parent_title', title);

        if (startButton && variantId) {
          startButton.classList.add('active', 'enabled');
          startButton.disabled = false;
        }
      }
    });
  });

  amountButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      amountButtons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      let selectedAmount = this.getAttribute('data-amount') || this.innerText.trim();

      sizeWrappers.forEach(w => w.classList.remove('active'));
      const targetWrapper = document.querySelector(`.pm-size-selection__wrapper[data-amount="${selectedAmount}"]`);
      if (targetWrapper) targetWrapper.classList.add('active');
      
      sizeButtons.forEach(b => b.classList.remove('active'));
      if (startButton) startButton.classList.remove('active', 'enabled');
    });
  });

  sizeButtons.forEach(btn => {
    btn.addEventListener('click', function() {
      const parentWrapper = this.closest('.pm-size-selection__wrapper');
      if (parentWrapper) {
        parentWrapper.querySelectorAll('.pm-size-selection__button').forEach(b => b.classList.remove('active'));
      }
      this.classList.add('active');

      const variantId = this.getAttribute('data-variant-id');
      const recipe = this.getAttribute('data-recipe'); 
      const image = this.getAttribute('data-image');
      const price = this.getAttribute('data-price');
      const title = this.querySelector('h3') ? this.querySelector('h3').innerText.trim() : '';

      if (variantId) localStorage.setItem('pnm_parent_id', variantId);
      if (recipe) localStorage.setItem('pnm_recipe', recipe);
      if (image) localStorage.setItem('pnm_parent_image', image);
      if (price) localStorage.setItem('pnm_parent_price', price);
      if (title) localStorage.setItem('pnm_parent_title', title);

      if (startButton) {
        startButton.classList.add('active', 'enabled');
        startButton.disabled = false;
      }
    });
  });
  
  if (startButton) {
    startButton.addEventListener('click', () => {
      localStorage.removeItem('pickMixSessionId');
    });
  }
});


// ==========================================
// 2. GLOBAL STATE & NATIVE POPUP LOGIC
// ==========================================
window.pnmActiveGridId = 'pm-original-grid'; 

window.openpm = function(popupId) {
  if (!popupId || popupId === 'popup-null' || popupId === 'popup-undefined') return;

  const popups = document.querySelectorAll(`[id="${popupId}"]`);
  
  if (popups.length > 0) {
    popups.forEach(popupElement => {
      if (popupElement.parentElement !== document.body) {
        document.body.appendChild(popupElement);
      }
      popupElement.style.display = "block";
    });
    document.body.classList.add("body-overflow");
  } else {
    console.error("Pick N Mix Error: Could not find popup element with ID:", popupId);
  }
};

window.closepm = function(popupId) {
  if (!popupId || popupId === 'popup-null') return;

  const popups = document.querySelectorAll(`[id="${popupId}"]`);
  popups.forEach(popupElement => {
    popupElement.style.display = "none";
    const successText = popupElement.querySelector(".text-success-text");
    if (successText) successText.style.display = "none";
    const formSubmissions = popupElement.querySelector(".contactFormSubmissions");
    if (formSubmissions) formSubmissions.style.display = "block";
  });
  document.body.classList.remove("body-overflow");
};

window.pnmRestoreGridVisibility = function() {
  const targetGridId = window.pnmActiveGridId || 'pm-original-grid';
  
  const originalGrid = document.getElementById('pm-original-grid');
  const ajaxGrid = document.getElementById('pm-ajax-grid');
  const pagination = document.querySelector('.pnm-pagination-wrapper');

  if (targetGridId === 'pm-original-grid') {
    if (originalGrid) originalGrid.style.display = 'grid';
    if (ajaxGrid) ajaxGrid.style.display = 'none';
    if (pagination) pagination.style.display = 'block';
  } else {
    if (originalGrid) originalGrid.style.display = 'none';
    if (ajaxGrid) ajaxGrid.style.display = 'grid';
    if (pagination) pagination.style.display = 'none';
  }
};


// ==========================================
// 3. CORE BUILDER LOGIC (The Grid Page)
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  const app = document.getElementById('pnm-app');
  if (!app) return;

  localStorage.removeItem("selectedProducts");

  const parentVariantId = localStorage.getItem('pnm_parent_id');
  const recipeRaw = localStorage.getItem('pnm_recipe');
  const parentImage = localStorage.getItem('pnm_parent_image');
  const parentPrice = parseFloat(localStorage.getItem('pnm_parent_price')) || 0;
  const parentTitle = localStorage.getItem('pnm_parent_title') || '';

  window.pnmConversionRate = 1;
  if (parentPrice > 0 && parentTitle && window.gbpBasePricing && window.gbpBasePricing[parentTitle]) {
    const baseGbp = parseFloat(window.gbpBasePricing[parentTitle]);
    if (baseGbp > 0) {
      window.pnmConversionRate = parentPrice / baseGbp;
    }
  } else if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
    window.pnmConversionRate = parseFloat(window.Shopify.currency.rate);
  }

  let dietaryCollection = localStorage.getItem("selectedCollection") || "all";
  dietaryCollection = dietaryCollection.toLowerCase().replace(/\s+/g, "-");

  if (!parentVariantId || !recipeRaw || recipeRaw === 'null') {
    document.getElementById('pm-original-grid').innerHTML = '<p style="grid-column: 1 / -1; text-align: center; padding: 50px;">Error: No container selected. Please go back.</p>';
    return;
  }

  if (parentImage) {
    document.querySelectorAll('.pnm-dynamic-cart-img').forEach(img => img.src = parentImage);
  }

  const sessionId = localStorage.getItem('pickMixSessionId') || `pnm_${Date.now()}`;
  localStorage.setItem('pickMixSessionId', sessionId);

  // PARSE JSON AND FIND CUSTOM BUTTON TEXT
  let customButtonText = "Add to Mix";
  let steps = [];
  try {
    const recipeData = JSON.parse(recipeRaw);
    
    if (recipeData.button_display) {
       customButtonText = recipeData.button_display;
    }

    if (Array.isArray(recipeData.steps)) {
      steps = recipeData.steps;
    } else if (Array.isArray(recipeData)) {
      steps = recipeData;
    } else {
      steps = [recipeData];
    }
  } catch(e) {
    console.error("Failed to parse JSON recipe", e);
  }
  
  let bundleState;
  const savedStateRaw = localStorage.getItem(`pnm_state_${sessionId}`);

  if (savedStateRaw) {
    bundleState = JSON.parse(savedStateRaw); 
  } else {
    bundleState = steps.map(step => ({
      title: step.step_title || "Choose Sweets",
      targetSize: (step.target_variant_title || "").toLowerCase().trim(),
      maxItems: step.max_items || 1,
      collectionOverride: step.collection_handle || null,
      selectedSweets: [], 
      totalItems: 0
    }));
  }

  let currentStepIndex = parseInt(localStorage.getItem(`pnm_step_${sessionId}`)) || 0;
  if (currentStepIndex >= bundleState.length) {
    currentStepIndex = bundleState.length - 1;
  }

  let currentlyLoadedCollection = ""; 
  let isProcessingClick = false; 
  let isInitialLoad = true;

  const originalGrid = document.getElementById('pm-original-grid'); 
  const ajaxGrid = document.getElementById('pm-ajax-grid'); 
  const searchGrid = document.getElementById('pm-search-results'); 
  
  const countDisplay = document.getElementById('pnm-count');
  const maxDisplay = document.getElementById('pnm-max');
  const stepTitleDisplay = document.getElementById('pnm-step-title');
  const searchInput = document.getElementById('pm-search-input');
  
  const sidebarStatus = document.getElementById('choice-status');
  const sidebarStatusMob = document.getElementById('choice-status-mobile');
  const priceDisplay = document.getElementById('priceDisplay');
  const priceDisplayMob = document.getElementById('priceDisplayMobile');
  const cartItemsContainerDesktop = document.getElementById('cart-items'); 
  const cartItemsContainerMobile = document.getElementById('cart-items-mobile'); 
  
  const nextContainer = document.getElementById('continueToNextStep');
  const nextBtn = document.getElementById('pnm-next-btn');
  const checkoutContainer = document.getElementById('continueToCart');
  const checkoutBtn = document.getElementById('pnm-checkout-btn');
  
  const nextContainerMob = document.getElementById('continueToNextStepMobile');
  const nextBtnMob = document.getElementById('pnm-next-btn-mobile');
  const checkoutContainerMob = document.getElementById('continueToCartMobile');
  const checkoutBtnMob = document.getElementById('pnm-checkout-btn-mobile');

  let syncTimeout;
  const domObserver = new MutationObserver((mutations) => {
    let requiresSync = false;
    for (let mutation of mutations) {
      if (mutation.addedNodes.length > 0 || mutation.attributeName === 'style') {
        requiresSync = true;
        break;
      }
    }
    if (requiresSync) {
      clearTimeout(syncTimeout);
      syncTimeout = setTimeout(() => { attachVariantLogic(); }, 150); 
    }
  });

  if (originalGrid) domObserver.observe(originalGrid, { childList: true, subtree: true });
  if (searchGrid) domObserver.observe(searchGrid, { childList: true, subtree: true });
  if (ajaxGrid) domObserver.observe(ajaxGrid, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    const pageLink = e.target.closest('.pnm-pagination-wrapper a');
    if (pageLink && (originalGrid.contains(pageLink) || ajaxGrid.contains(pageLink))) {
      e.preventDefault();
      loadStep(pageLink.href);
      window.scrollTo({ top: originalGrid.offsetTop - 50, behavior: 'smooth' });
    }
  });

  async function loadStep(customUrl = null) {
    const currentStep = bundleState[currentStepIndex];
    const stepCollection = currentStep.collectionOverride || dietaryCollection;
    
    localStorage.setItem('pnm_current_step_collection', stepCollection);

    if (currentlyLoadedCollection !== stepCollection && !customUrl) {
      if (typeof window.pnmUpdateSearchDatabase === 'function') {
        window.pnmUpdateSearchDatabase(stepCollection);
      } else {
        setTimeout(() => {
          if (typeof window.pnmUpdateSearchDatabase === 'function') {
            window.pnmUpdateSearchDatabase(stepCollection);
          }
        }, 500);
      }
    }

    if (searchInput && searchInput.value) {
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input')); 
    }
    if (searchGrid) searchGrid.style.display = 'none';

    if (currentStepIndex === 0) {
      isInitialLoad = false;
      currentlyLoadedCollection = stepCollection; 
      window.pnmActiveGridId = 'pm-original-grid';
      window.pnmRestoreGridVisibility(); 
      attachVariantLogic();
      updateUI();
      return;
    }

    if (!isInitialLoad && currentlyLoadedCollection === stepCollection && !customUrl) {
      window.pnmRestoreGridVisibility();
      attachVariantLogic();
      updateUI();
      return;
    }

    isInitialLoad = false;
    window.pnmActiveGridId = 'pm-ajax-grid';
    window.pnmRestoreGridVisibility();

    if (ajaxGrid) {
      ajaxGrid.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; padding: 50px;">Loading next step...</p>';
    }

    const pagination = document.querySelector('.pnm-pagination-wrapper');
    if (pagination) pagination.style.display = 'none';

    try {
      const firstResp = await fetch(`/collections/${stepCollection}?view=json-data&page=1`);
      if (!firstResp.ok) throw new Error('Failed to load JSON data for next step');
      const firstData = await firstResp.json();
      
      let allProducts = [...firstData.products];
      const totalPages = Math.ceil(firstData.info.results_count / 50);

      if (totalPages > 1) {
          const fetchPromises = [];
          for (let i = 2; i <= totalPages; i++) {
              fetchPromises.push(fetch(`/collections/${stepCollection}?view=json-data&page=${i}`).then(res => res.json()).catch(() => ({ products: [] })));
          }
          const results = await Promise.all(fetchPromises);
          results.forEach(data => { if (data.products) allProducts = allProducts.concat(data.products); });
      }

      if (ajaxGrid) {
          ajaxGrid.innerHTML = '';
          if (allProducts.length === 0) {
              ajaxGrid.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; padding: 50px;">No sweets available in this section.</p>';
          } else {
              allProducts.forEach(p => {
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = p.html.trim();
                  const card = tempDiv.querySelector('.collection--grid-product') || tempDiv.querySelector('.product--root') || tempDiv.firstElementChild;
                  
                  if (card) {
                      card.classList.add('collection--grid-product');
                      if (!card.getAttribute('data-product-id')) card.setAttribute('data-product-id', p.id);
                      
                      if (!card.querySelector('.pnm-variant-data')) {
                          // CHANGE A: Now captures 'price' AND 'surcharge' for the AJAX grid
                          const variantData = p.variants.map(v => ({ id: v.id, title: v.title, available: true, price: v.price, surcharge: v.surcharge || null }));
                          const scriptTag = document.createElement('script');
                          scriptTag.type = 'application/json';
                          scriptTag.className = 'pnm-variant-data';
                          scriptTag.textContent = JSON.stringify(variantData);
                          card.appendChild(scriptTag);
                      }
                      ajaxGrid.appendChild(card);
                  }
              });
          }
      }
      
      currentlyLoadedCollection = stepCollection; 
      attachVariantLogic();
      updateUI();
      
    } catch (err) {
      console.error("Pick N Mix AJAX Error:", err);
      if (ajaxGrid) ajaxGrid.innerHTML = '<p style="grid-column: 1 / -1; text-align: center; padding: 50px;">Error loading products.</p>';
    }
  }

  window.pnmAttachVariantLogic = attachVariantLogic;

  function attachVariantLogic() {
    domObserver.disconnect(); 

    const currentStep = bundleState[currentStepIndex];
    const isFull = currentStep.totalItems >= currentStep.maxItems;

    const activeGrids = [];
    const mainGrid = document.getElementById(window.pnmActiveGridId || 'pm-original-grid');
    if (mainGrid) activeGrids.push(mainGrid);
    
    const searchGridNode = document.getElementById('pm-search-results');
    if (searchGridNode) activeGrids.push(searchGridNode);

    activeGrids.forEach(gridNode => {
      gridNode.querySelectorAll('.collection--grid-product').forEach(card => {
        const variantDataNode = card.querySelector('.pnm-variant-data');
        if (!variantDataNode) return;
        
        let productId = card.getAttribute('data-product-id');
        if (!productId) {
           const innerRoot = card.querySelector('.product--root');
           if (innerRoot) productId = innerRoot.getAttribute('data-product-id');
        }
        if (!productId) {
           const popupBtn = card.querySelector('button[onclick*="openpm"]');
           if (popupBtn) {
              const match = popupBtn.getAttribute('onclick').match(/popup-(\d+)/);
              if (match) productId = match[1];
           }
        }

        const variants = JSON.parse(variantDataNode.textContent);
        const btns = card.querySelectorAll('.add-to-cart-btn'); 
        const disabledBtns = card.querySelectorAll('.add-to-cart-btn__disabled');
        const qtyWrappers = card.querySelectorAll('.quantity-controls');
        
        let sweetTitle = '';
        const titleSelectors = ['.title-desktop', '.title-mobile', '.product--title', '.grid-product__title', 'h3', 'h2'];
        
        for (let selector of titleSelectors) {
          const els = card.querySelectorAll(selector);
          els.forEach(el => {
            if (sweetTitle) return; 
            
            const clone = el.cloneNode(true);
            clone.querySelectorAll('small, span, div, .corner-price, .corner-price-other').forEach(child => child.remove());
            let txt = clone.textContent.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
            
            if (txt.length > 2 && txt.toLowerCase() !== 'add to cart' && txt.toLowerCase() !== 'sold out') {
              sweetTitle = txt;
            }
          });
        }

        if (!sweetTitle || sweetTitle === 'Sweet') {
          const imgEl = card.querySelector('img');
          if (imgEl && imgEl.alt && imgEl.alt.trim().length > 2) {
             sweetTitle = imgEl.alt.trim();
          } else {
             sweetTitle = 'Sweet';
          }
        }
        
        const imgEl = card.querySelector('img');
        const sweetImage = imgEl ? imgEl.src : '';

        // --- UPGRADED PRICING ENGINE ---
        const surchargeEls = card.querySelectorAll('.corner-price, .corner-price-other');
        
        // 1. Find correct variant 
        const target = currentStep.targetSize;
        let correctVariant = variants.find(v => {
          const options = v.title.toLowerCase().split('/').map(opt => opt.trim());
          return options.includes(target);
        });

        if (!correctVariant) {
          correctVariant = variants.find(v => v.title.toLowerCase().trim().includes(target));
        }

        let sweetPrice = null; 
        
        // 2. CHECK THE METAFIELD (This is the true surcharge price)
        if (correctVariant && 'surcharge' in correctVariant && correctVariant.surcharge !== null) {
          let sVal = correctVariant.surcharge;
          
          if (typeof sVal === 'object' && sVal !== null) {
            sVal = sVal.amount || sVal.value || "0";
          }
          if (sVal === "") sVal = "0";
          
          let parsedSurcharge = parseFloat(String(sVal).replace(/[^\d.]/g, ""));
          if (!isNaN(parsedSurcharge) && parsedSurcharge > 0) {
            let converted = parsedSurcharge * (window.pnmConversionRate || 1);
            if (!window.pnmCurrencyIso || window.pnmCurrencyIso === 'GBP') {
              sweetPrice = Math.ceil(converted * 100) / 100;
            } else {
              sweetPrice = Math.ceil(converted);
            }
          }
        }
        
        // If the true variant price is 0, explicitly set it to 0 so we hide the tag
        if (sweetPrice === null) sweetPrice = 0;

        // 5. UPDATE OR CREATE THE TAGS
        const titleElements = card.querySelectorAll('.title-desktop, .title-mobile, .product--title, .grid-product__title');
        
        titleElements.forEach(titleEl => {
          let surchargeEl = titleEl.querySelector('.corner-price, .corner-price-other, .pnm-dynamic-surcharge');
          
          if (sweetPrice > 0) {
            const newHTML = `+ ${pnmFormatMoney(sweetPrice)}`;
            
            if (surchargeEl) {
              if (surchargeEl.innerHTML !== newHTML) surchargeEl.innerHTML = newHTML;
              if (surchargeEl.style.display !== 'inline-block') surchargeEl.style.display = 'inline-block';
            } else {
              const newTag = document.createElement('small');
              newTag.className = 'corner-price pnm-dynamic-surcharge';
              newTag.innerHTML = newHTML;
              newTag.style.marginLeft = '5px';
              titleEl.appendChild(newTag);
            }
          } else {
             // Size is free or 0, forcefully hide any scraped 50g tags!
             if (surchargeEl) surchargeEl.style.display = 'none';
          }
        });
        // --- END UPGRADED PRICING ENGINE ---

        if (correctVariant && correctVariant.available) {
          // 1. THE REVEAL: Ensure the card is visible if it is in stock!
          if (card.style.display === 'none') card.style.display = '';

          const currentQty = getSweetQuantity(correctVariant.id);
          
          btns.forEach(btn => {
            if (isFull && currentQty === 0) {
              if (btn.style.display !== 'inline-flex') btn.style.display = 'inline-flex'; 
              if (btn.style.justifyContent !== 'center') btn.style.justifyContent = 'center';
              if (btn.innerText !== 'Section Full') btn.innerText = 'Section Full';
              if (!btn.disabled) btn.disabled = true;
              if (btn.style.opacity !== '0.5') btn.style.opacity = '0.5';
            } else if (currentQty > 0) {
              if (btn.style.display !== 'none') btn.style.display = 'none';
            } else {
              if (btn.style.display !== 'inline-flex') btn.style.display = 'inline-flex'; 
              if (btn.style.justifyContent !== 'center') btn.style.justifyContent = 'center';
              if (btn.innerText !== customButtonText) btn.innerText = customButtonText;
              if (btn.disabled) btn.disabled = false;
              if (btn.style.opacity !== '1') btn.style.opacity = '1';
              btn.classList.remove('out-of-stock');
            }

            btn.onclick = null;
            if (!btn.disabled && currentQty === 0) {
              btn.onclick = (e) => {
                e.preventDefault(); e.stopPropagation();
                if (isProcessingClick) return;
                isProcessingClick = true;
                if (handleAddSweet(correctVariant.id, sweetTitle, sweetImage, sweetPrice, 1, productId)) attachVariantLogic();
                setTimeout(() => { isProcessingClick = false; }, 150); 
              };
            }
          });

          qtyWrappers.forEach(wrapper => {
            const qtyMinus = wrapper.querySelector('.decrease-quantity');
            const qtyPlus = wrapper.querySelector('.increase-quantity');
            const qtyInput = wrapper.querySelector('.quantity-input');

            if (isFull && currentQty === 0) {
              if (wrapper.style.display !== 'none') wrapper.style.display = 'none';
            } else if (currentQty > 0) {
              if (wrapper.style.display !== 'flex') wrapper.style.display = 'flex'; 
              if (qtyInput && qtyInput.value != currentQty) qtyInput.value = currentQty;
              if (qtyPlus) {
                if (qtyPlus.disabled !== isFull) qtyPlus.disabled = isFull; 
                const intendedOpacity = isFull ? '0.5' : '1';
                if (qtyPlus.style.opacity !== intendedOpacity) qtyPlus.style.opacity = intendedOpacity;
              }
            } else {
              if (wrapper.style.display !== 'none') wrapper.style.display = 'none';
              if (qtyInput && qtyInput.value != 0) qtyInput.value = 0;
            }

            if (qtyPlus) {
              qtyPlus.onclick = null;
              if (!qtyPlus.disabled) {
                qtyPlus.onclick = (e) => {
                  e.preventDefault(); e.stopPropagation();
                  if (isProcessingClick) return;
                  isProcessingClick = true;
                  if (handleAddSweet(correctVariant.id, sweetTitle, sweetImage, sweetPrice, 1, productId)) attachVariantLogic();
                  setTimeout(() => { isProcessingClick = false; }, 150); 
                };
              }
            }

            if (qtyMinus) {
              qtyMinus.onclick = null;
              qtyMinus.onclick = (e) => {
                e.preventDefault(); e.stopPropagation();
                if (isProcessingClick) return;
                isProcessingClick = true;
                if (handleRemoveSweet(correctVariant.id)) attachVariantLogic(); 
                setTimeout(() => { isProcessingClick = false; }, 150); 
              };
            }
          });

          disabledBtns.forEach(btn => {
            if (btn.style.display !== 'none') btn.style.display = 'none';
          });

        } else {
          // 2. THE HIDE: Physically remove the card from the grid!
          if (card.style.display !== 'none') card.style.display = 'none';

          // We keep the inner buttons hidden just as a fallback
          btns.forEach(btn => {
            if (btn.style.display !== 'none') btn.style.display = 'none';
          });
          qtyWrappers.forEach(wrapper => {
            if (wrapper.style.display !== 'none') wrapper.style.display = 'none';
          });
        }
      });
    });

    if (originalGrid) domObserver.observe(originalGrid, { childList: true, subtree: true });
    if (searchGridNode) domObserver.observe(searchGridNode, { childList: true, subtree: true });
    const ajaxGrid = document.getElementById('pm-ajax-grid');
    if (ajaxGrid) domObserver.observe(ajaxGrid, { childList: true, subtree: true });
  }

  function getSweetQuantity(variantId) {
    const currentStep = bundleState[currentStepIndex];
    const existing = currentStep.selectedSweets.find(i => String(i.id) === String(variantId));
    return existing ? existing.quantity : 0;
  }

  function handleAddSweet(variantId, sweetTitle, sweetImage, sweetPrice, amount, productId) {
    const currentStep = bundleState[currentStepIndex];
    if (currentStep.totalItems >= currentStep.maxItems) return false; 

    const existing = currentStep.selectedSweets.find(i => String(i.id) === String(variantId));
    if (existing) {
      existing.quantity += amount;
    } else {
      currentStep.selectedSweets.push({ 
        id: variantId, 
        title: sweetTitle, 
        image: sweetImage, 
        price: sweetPrice, 
        quantity: amount,
        productId: productId || '' 
      });
    }

    currentStep.totalItems += amount;
    updateUI();
    return true; 
  }

  function handleRemoveSweet(variantId) {
    const currentStep = bundleState[currentStepIndex];
    const existing = currentStep.selectedSweets.find(i => String(i.id) === String(variantId));
    
    if (!existing || existing.quantity <= 0) return false;

    existing.quantity -= 1;
    currentStep.totalItems -= 1;

    if (existing.quantity === 0) {
      currentStep.selectedSweets = currentStep.selectedSweets.filter(i => String(i.id) !== String(variantId));
    }

    updateUI();
    return true;
  }

  function renderSidebarCart() {
    const currentStep = bundleState[currentStepIndex];
    const remaining = currentStep.maxItems - currentStep.totalItems;
    
    const statusText = remaining > 0 ? `<span>${remaining}</span> choices left!` : `Section Complete!`;
    if (sidebarStatus && sidebarStatus.innerHTML !== statusText) sidebarStatus.innerHTML = statusText;
    if (sidebarStatusMob && sidebarStatusMob.innerHTML !== statusText) sidebarStatusMob.innerHTML = statusText;

    let totalSurcharge = 0;
    const svgIcon = `<svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_7_1516)"><path d="M25.2304 10.2309C22.8417 4.96289 18.1086 1.375 12.6923 1.375C7.27604 1.375 2.54243 4.96719 0.152881 10.2309C0.0688822 10.4586 0 10.7852 0 11C0 11.2139 0.0688381 11.5414 0.152881 11.7318C2.54375 17.0371 7.27604 20.625 12.6923 20.625C18.1086 20.625 22.8417 17.0337 25.2304 11.7691C25.3141 11.5414 25.3846 11.1762 25.3846 11C25.3846 10.7852 25.3141 10.4586 25.2304 10.2309ZM12.6923 18.5625C8.30817 18.5625 4.26603 15.6621 2.13301 11.0387C4.27528 6.33359 8.3117 3.4375 12.6923 3.4375C17.0764 3.4375 21.1186 6.33789 23.2516 10.9613C21.0701 15.6664 17.0729 18.5625 12.6923 18.5625ZM12.6923 5.5C9.57652 5.5 7.05128 7.96211 7.05128 11C7.05128 14.0379 9.57784 16.5 12.6923 16.5C15.8054 16.5 18.3333 14.037 18.3333 11.0043C18.3333 7.96641 15.8081 5.5 12.6923 5.5ZM12.6923 14.4375C10.7484 14.4375 9.16667 12.8954 9.16667 11C9.16667 10.9679 9.17545 10.9381 9.17639 10.9062C9.40024 10.9613 9.62941 11 9.87179 11C11.4297 11 12.6923 9.76895 12.6923 8.25C12.6923 8.01453 12.6537 7.78937 12.5961 7.57195C12.6306 7.57109 12.6615 7.5625 12.6923 7.5625C14.6363 7.5625 16.2179 9.10465 16.2179 11.0021C16.2179 12.8949 14.6358 14.4375 12.6923 14.4375Z" fill="black"/></g></svg>`;

    let html = '';
    bundleState.forEach((step, stepIdx) => {
      step.selectedSweets.forEach(sweet => {
        totalSurcharge += (sweet.price * sweet.quantity);
        html += `
          <li class="cart-item" data-variant-id="${sweet.id}">
            <img src="${sweet.image}?width=150" alt="${sweet.title}" width="80">
            <div class="cartQuantityRemove">
              <p class="cart-item-quantity">${sweet.quantity}</p>
              <button class="remove-item-btn pnm-sidebar-remove" data-variant-id="${sweet.id}" data-step-index="${stepIdx}">X</button>
            </div>
            <div class="product-quick__view quick-view-js">
              <button onclick="window.openpm('popup-${sweet.productId}')">${svgIcon}</button>
            </div>
            <div class="cart-item-details" style="opacity: ${sweet.price > 0 ? "1" : "0"};">
              <p>+ ${pnmFormatMoney(sweet.price)}</p>
            </div>
          </li>
        `;
      });
    });
    
    const finalPrice = parentPrice + totalSurcharge;
    const formattedPrice = pnmFormatMoney(finalPrice);

    if (priceDisplay && priceDisplay.innerText !== formattedPrice) priceDisplay.innerText = formattedPrice;
    if (priceDisplayMob && priceDisplayMob.innerText !== formattedPrice) priceDisplayMob.innerText = formattedPrice;

    if (cartItemsContainerDesktop) cartItemsContainerDesktop.innerHTML = html;
    if (cartItemsContainerMobile) cartItemsContainerMobile.innerHTML = html;

    document.querySelectorAll('.pnm-sidebar-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); e.stopPropagation();
        const id = btn.dataset.variantId;
        const targetStepIdx = parseInt(btn.dataset.stepIndex);
        const step = bundleState[targetStepIdx];
        const existing = step.selectedSweets.find(i => String(i.id) === String(id));
        
        if (existing) {
          const removedQty = existing.quantity;
          step.totalItems -= removedQty;
          step.selectedSweets = step.selectedSweets.filter(i => String(i.id) !== String(id));

          const firstIncompleteStepIndex = bundleState.findIndex(s => s.totalItems < s.maxItems);
          
          if (firstIncompleteStepIndex !== -1 && firstIncompleteStepIndex < currentStepIndex) {
            currentStepIndex = firstIncompleteStepIndex;
            updateUI(); 
            loadStep();
            const wrapper = document.querySelector('.pm-page__wrapper');
            window.scrollTo({ top: wrapper ? wrapper.offsetTop - 50 : 0, behavior: 'smooth' });
          } else {
            updateUI();
            attachVariantLogic();
          }
        }
      });
    });
  }

  function updateUI() {
    localStorage.setItem(`pnm_state_${sessionId}`, JSON.stringify(bundleState));
    localStorage.setItem(`pnm_step_${sessionId}`, currentStepIndex);

    const currentStep = bundleState[currentStepIndex];
    const displaySuffix = currentStep.collectionOverride ? "" : ` (${dietaryCollection.toUpperCase()})`;
    
    const expectedTitle = `${currentStep.title}${displaySuffix}`;
    if (stepTitleDisplay && stepTitleDisplay.innerText !== expectedTitle) stepTitleDisplay.innerText = expectedTitle;
    
    if (countDisplay && parseInt(countDisplay.innerText) !== currentStep.totalItems) countDisplay.innerText = currentStep.totalItems;
    if (maxDisplay && parseInt(maxDisplay.innerText) !== currentStep.maxItems) maxDisplay.innerText = currentStep.maxItems;
    
    renderSidebarCart();

    const isCurrentStepFull = currentStep.totalItems >= currentStep.maxItems;
    const isLastStep = currentStepIndex === (bundleState.length - 1);

    if (isCurrentStepFull) {
      if (isLastStep) {
        if (priceDisplay) priceDisplay.style.display = 'none';
        if (priceDisplayMob) priceDisplayMob.style.display = 'none';
        if (sidebarStatus) sidebarStatus.style.display = 'none';
        if (sidebarStatusMob) sidebarStatusMob.style.display = 'none';
        
        if (nextContainer) nextContainer.style.display = 'none';
        if (nextContainerMob) nextContainerMob.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        if (nextBtnMob) nextBtnMob.style.display = 'none';
        
        if (checkoutContainer) checkoutContainer.style.display = 'block'; 
        if (checkoutContainerMob) checkoutContainerMob.style.display = 'block';
        if (checkoutBtn) checkoutBtn.style.display = 'flex'; 
        if (checkoutBtnMob) checkoutBtnMob.style.display = 'flex';
      } else {
        if (priceDisplay) priceDisplay.style.display = 'block';
        if (priceDisplayMob) priceDisplayMob.style.display = 'block';
        if (sidebarStatus) sidebarStatus.style.display = 'block';
        if (sidebarStatusMob) sidebarStatusMob.style.display = 'block';
        
        if (checkoutContainer) checkoutContainer.style.display = 'none';
        if (checkoutContainerMob) checkoutContainerMob.style.display = 'none';
        if (checkoutBtn) checkoutBtn.style.display = 'none';
        if (checkoutBtnMob) checkoutBtnMob.style.display = 'none';
        
        if (nextContainer) nextContainer.style.display = 'block';
        if (nextContainerMob) nextContainerMob.style.display = 'block';
        if (nextBtn) nextBtn.style.display = 'flex';
        if (nextBtnMob) nextBtnMob.style.display = 'flex';
      }
    } else {
      if (priceDisplay) priceDisplay.style.display = 'block';
      if (priceDisplayMob) priceDisplayMob.style.display = 'block';
      if (sidebarStatus) sidebarStatus.style.display = 'block';
      if (sidebarStatusMob) sidebarStatusMob.style.display = 'block';

      if (nextContainer) nextContainer.style.display = 'none';
      if (nextContainerMob) nextContainerMob.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      if (nextBtnMob) nextBtnMob.style.display = 'none';
      
      if (checkoutContainer) checkoutContainer.style.display = 'none';
      if (checkoutContainerMob) checkoutContainerMob.style.display = 'none';
      if (checkoutBtn) checkoutBtn.style.display = 'none';
      if (checkoutBtnMob) checkoutBtnMob.style.display = 'none';
    }
  }

  function handleNextStep(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (currentStepIndex < bundleState.length - 1) {
      currentStepIndex += 1;
      localStorage.setItem(`pnm_step_${sessionId}`, currentStepIndex);
      loadStep(); 
      const wrapper = document.querySelector('.pm-page__wrapper');
      window.scrollTo({ top: wrapper ? wrapper.offsetTop - 50 : 0, behavior: 'smooth' });
    }
  }

  async function submitBundle(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const overlay = document.getElementById("cartOverlay");
    if (overlay) {
      overlay.style.display = "flex";
      document.body.classList.add("body-overflow");
    }

    let parentProperties = { 
      '_Pick Mix Session': sessionId, 
      '_Main Product': 'true', 
      '_Dietary Requirement': dietaryCollection 
    };

    bundleState.forEach((step, index) => {
      if (step.selectedSweets.length > 0) {
        const summaryString = step.selectedSweets.map(s => `${s.title} (Qty: ${s.quantity})`).join(", ");
        parentProperties[`_Step ${index + 1} - ${step.title}`] = summaryString;
      }
    });

    let allChildItems = [];
    bundleState.forEach(step => {
      step.selectedSweets.forEach(sweet => {
        const existing = allChildItems.find(item => item.id === sweet.id);
        if (existing) {
          existing.quantity += sweet.quantity;
        } else {
          allChildItems.push({ 
            id: sweet.id, 
            quantity: sweet.quantity, 
            properties: { 
              '_pickMixSessionId': sessionId,
              '_isPMchoicetrue': 'isPMchoicetrue',
              '_v2TestingEnv': 'active'
            } 
          });
        }
      });
    });

    const itemsPayload = [
      { id: parseInt(parentVariantId), quantity: 1, properties: parentProperties },
      ...allChildItems
    ];

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsPayload })
      });
      if (res.ok) {
        localStorage.removeItem(`pnm_state_${sessionId}`);
        localStorage.removeItem(`pnm_step_${sessionId}`);
        localStorage.removeItem('pickMixSessionId');
        
        if (overlay) overlay.style.display = "none";
        const popup = document.getElementById('cart-popup');
        if (popup) {
          popup.style.display = 'block';
          document.body.classList.add("body-overflow");
        }
      }
    } catch (err) {
      if (overlay) overlay.style.display = "none";
      alert("Error adding to cart. Please try again.");
    }
  }

  if (nextBtn) nextBtn.addEventListener('click', handleNextStep);
  if (nextBtnMob) nextBtnMob.addEventListener('click', handleNextStep);
  if (checkoutBtn) checkoutBtn.addEventListener('click', submitBundle);
  if (checkoutBtnMob) checkoutBtnMob.addEventListener('click', submitBundle);

  loadStep();
});